/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { injectIntl } from 'react-intl';
import { Panel } from 'react-bootstrap';
import { callAPI } from 'lorautils/api';
import GatewayMap from 'loracoms/GatewayMap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles.scss';


const propTypes = {
  intl: React.PropTypes.object.isRequired,
};

class GatewayMapPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.intlMsg = new IntlMsg(props.intl, 'overview');
  }

  componentWillMount() {
    callAPI({
      endpoint: '/lora/gateways',
      query: { limit: 100 },
    }).then((data) => {
      this.setState({ gateways: data.list });
    }).catch(() => {});
  }

  render() {
    const { gateways = [] } = this.state;
    return (
      <Panel bsStyle="aisz-white" header={this.intlMsg.msg('gatewaymap')}>
        <div className={styles.map}>
          <GatewayMap gateways={gateways} />
        </div>
      </Panel>
    );
  }
}

GatewayMapPanel.propTypes = propTypes;

export default injectIntl(GatewayMapPanel);




// WEBPACK FOOTER //
// ./src/containers/Overview/GatewayMapPanel/index.jsx